export default "__VITE_ASSET__D6xpsNF7__"